import {gql} from '@apollo/client';

export default gql`
  mutation rejectAd($input: RejectAdInput!) {
    rejectAd(input: $input) {
      success
    }
  }
`;
